module.exports = __webpack_public_path__ + "static/img/numwuman.d2b4b4bb.png";